import Datetime from './SchemaDatetime'
import Textarea from './SchemaTextarea'
import Number from './SchemaNumber'
import Select from './SchemaSelect'
import MultiSelect from './SchemaMultiSelect'
import Input from './SchemaInput'
import Hidden from './SchemaHidden'
import DatetimeRange from './SchemaDatetimeRange'
import Tree from './SchemaTree'
import CheckTree from './SchemaCheckTree'
import TableSelect from './SchemaTableSelect'

export {
  Datetime,
  Textarea,
  Number,
  Select,
  MultiSelect,
  Input,
  Hidden,
  DatetimeRange,
  Tree,
  CheckTree,
  TableSelect
}

export default {
  Datetime,
  Textarea,
  Number,
  Select,
  MultiSelect,
  Input,
  Hidden,
  DatetimeRange,
  Tree,
  CheckTree,
  TableSelect
}



// WEBPACK FOOTER //
// ./packages/helper/schema/index.js